// extracted by mini-css-extract-plugin
export var labelWrapper = "_hx-0";